/* eslint-disable import/group-exports -- Repeating each key as a named export would be too repetitive.
Since this file only contains exported keys the module's API surface remains readable. */
export const LocalStorageKeyUseFirestoreEmulator = 'UseFirestoreEmulator';
export const LocalStorageKeyTheme = 'Theme';
/* eslint-enable import/group-exports -- Enable */
